"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const { get } = require('lodash');
class QuestionsMatrix {
    constructor(modules = []) {
        this.poll = undefined;
        this.modules = [];
        this.modules = modules;
    }
    matchId(id) {
        return this.modules.find((question) => question.id === id);
    }
    get id() {
        return this.modules[0].id;
    }
    get type() {
        return this.modules[0].type;
    }
    push(question) {
        this.modules.push(question);
    }
    getGroup() {
        return this.modules[0] && this.modules[0].getGroup();
    }
    getNext() {
        var _a;
        if (!((_a = this.poll) === null || _a === void 0 ? void 0 : _a.getNextTo(this))) {
            return {
                error: 'END',
                isLast: true,
            };
        }
        return {
            nextItem: this.poll.getNextTo(this),
        };
    }
    getErrors({ answers = [] }) {
        // @ts-ignore
        return this.modules.reduce((reduced, question) => [
            ...reduced,
            ...question.getErrors({ answers }),
        ], []);
    }
    getScoreErrors({ answer, answers = [] }) {
        // @ts-ignore
        return this.modules.reduce((reduced, question) => [
            ...reduced,
            ...question.getScoreErrors({ answer, answers }),
        ], []);
    }
    getMatrixTitle() {
        return {
            text: get(this.modules[0], 'metadata.settings.group'),
            style: {
                fontSize: get(this.modules[0], 'metadata.settings.titleSize'),
                // color: get(this.modules[0],"metadata.settings.color")
            },
        };
    }
    getMatrixDescription() {
        return {
            text: get(this.modules[0], 'metadata.settings.description'),
            style: {
                fontSize: get(this.modules[0], 'metadata.settings.descriptionSize', get(this.modules[0], 'metadata.settings.titleSize')),
                // color: get(this.modules[0],"metadata.settings.color")
            },
        };
    }
    getMatrixScoreType() {
        return get(this, 'modules[0].score_type');
    }
    getMotives() {
        return get(this, 'modules.0.motives', []);
    }
    getMatrixScore() {
        return get(this, 'modules[0].metadata.settings.score');
    }
    getMatrixScoreLabels() {
        return get(this, 'modules[0].metadata.settings.score.labels', []);
    }
    getMatrixOrder() {
        return get(this, 'modules[0].metadata.settings.score.order', 'default');
    }
    getMatrixVoteFontSize() {
        return get(this, 'modules[0].metadata.settings.voteFontSize', 12);
    }
    getMatrixTopLayout() {
        return get(this, 'modules[0].metadata.settings.topLayout');
    }
    hasMotives() {
        return this.modules[0].hasMotives();
    }
    hasErrors(values) {
        return this.modules.find((question) => !question.isResponseValid(values));
    }
    hasQuestionWithNA() {
        return this.modules.find((module) => module.metadata.settings.allowScoreNA === true);
    }
    get isBreaker() {
        return get(this.modules[get(this, 'modules', []).length - 1], 'metadata.settings.break', false);
    }
    isStepable() {
        return 1;
    }
    getSubModules() {
        return this.modules;
    }
    isResponseValid(answers) {
        const errors = this.getErrors({ answers });
        return errors.length === 0;
    }
}
exports.default = QuestionsMatrix;
